import { create } from "zustand";
import axiosInstance from "../api/axiosInstance";
import { useMatchStore } from "./useMatchStore";


interface ProfileUpdateState {
  setmainPhoto:number;
  loading: boolean;
  activeSection: string | null;
  updatedDetails: Record<string, any>;
  setActiveSection: (section: string | null) => void;
  updateDetails: (key: string, value: any) => void;
  resetDetails: () => void;
  uploadUserImage: (userId: number, file: File) => Promise<string | null>;
  deleteImage: (photoId: number) => Promise<void>;
  setMainProfile: (userId: number, file: File) => Promise<void>;
  setMainImage: (id: number) => Promise<void>;
  updateProfile: (userId: string, data: any) => Promise<void>;
}

export const useProfileUpdateStore = create<ProfileUpdateState>((set) => ({
  activeSection: null,
  setmainPhoto:0,
  updatedDetails: {},
  loading: false,
  

  setActiveSection: (section) => set({ activeSection: section }),

  updateDetails: (key, value) =>
    set((state) => ({
      updatedDetails: { ...state.updatedDetails, [key]: value },
    })),

  resetDetails: () => set({ updatedDetails: {} }),

  updateProfile: async (userId, data) => {
    set({ loading: true });

    try {
      // Assume you have an API function to update the profile
      const response = await axiosInstance.post(`/updateProfile`, 
      {id:userId, data:data},
      );

      if (response.status !== 200) throw new Error("Failed to update profile");

      //update cached profile on updte profile
       const usermatch= useMatchStore.getState();
       
       usermatch.getMatch(-1);
   

      set({ updatedDetails: {}, loading: false });
    } catch (error) {
      console.error("Error updating profile:", error);
      set({ loading: false });
    }
  },
  uploadUserImage: async (userId, file) => {
    try {
      set({ loading: true });
      const formData = new FormData();
      formData.append("file", file);
      formData.append("id", userId.toString());

      const response = await axiosInstance.post("/user_Addimage", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.status === 200) {
        set({ loading: false });
        const newImageUrl = response.data.picture;

        set((state) => ({
          updatedDetails: { ...state.updatedDetails, profileImage: newImageUrl },
        }));

        return newImageUrl;
      } else {
        set({ loading: false });
        console.error("Upload failed:", response.data);
        return null;
      }
    } catch (error) {
      set({ loading: false });
      console.error("Error uploading image:", error);
      return null;
    }
  },

  deleteImage: async (photoId) => {
    try {
      const response = await axiosInstance.post("/user_deleteimage", { id: photoId });

      if (response.status === 200) {
        console.log(`Photo ${photoId} deleted successfully.`);
      } else {
        console.error("Failed to delete photo:", response.data);
      }
    } catch (error) {
      console.error("Error deleting photo:", error);
    }
  },

  setMainProfile: async (userId, file) => {
    try {
      set({ loading: true });
      const formData = new FormData();
      formData.append("file", file);
      formData.append("id", userId.toString());
      formData.append("main_photo", '1');

      const response = await axiosInstance.post("/user_Addimage", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.status === 200) {
        set({ loading: false });
        console.log(`Photo ${userId} set as main successfully.`);
        // set((state) => ({
        //   updatedDetails: { ...state.updatedDetails, mainImage: photoId },
        // }));
        // set({setmainPhoto:photoId});
        
      } else {
        set({ loading: false });
        console.error("Failed to set main image:", response.data);
      }
    } catch (error) {
      set({ loading: false });
      console.error("Error setting main image:", error);
    }
  },

  setMainImage: async (photoId) => {
    try {

 

      const response = await axiosInstance.post("/setMainProfile", {id:photoId});

      if (response.status === 200) {
        console.log(`Photo ${photoId} set as main successfully.`);
        set((state) => ({
          updatedDetails: { ...state.updatedDetails, mainImage: photoId },
        }));
        set({setmainPhoto:photoId});
        
      } else {
        console.error("Failed to set main image:", response.data);
      }
    } catch (error) {
      console.error("Error setting main image:", error);
    }
  },
}));


